// 🔸 Kode lama dinonaktifkan sementara
		/*
class SearchForm extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector('input[type="search"]');
		//this.resetButton = this.querySelector('button[type="reset"]');

		if (this.input) {
			this.input.form.addEventListener("reset", this.onFormReset.bind(this));
			this.input.addEventListener(
				"input",
				debounce((event) => {
					this.onChange(event);
				}, 300).bind(this)
			);
		}
	}

	//toggleResetButton() {
	//	const resetIsHidden = this.resetButton.classList.contains("hidden");
	//	console.log("resetIsHidden -->", resetIsHidden);
	//	if (this.input.value.length > 0 && resetIsHidden) {
	//		this.resetButton.classList.remove("hidden");
	//	} else if (this.input.value.length === 0 && !resetIsHidden) {
	//		this.resetButton.classList.add("hidden");
	//	}
	//}

	//onChange() {
	//	this.toggleResetButton();
	//}

	shouldResetForm() {
		return !document.querySelector('[aria-selected="true"] a');
	}

	onFormReset(event) {
		// Prevent default so the form reset doesn't set the value gotten from the url on page load
		event.preventDefault();
		// Don't reset if the user has selected an element on the predictive search dropdown
		if (this.shouldResetForm()) {
			this.input.value = "";
			this.input.focus();
			//this.toggleResetButton();
		}
	}
}

customElements.define("search-form", SearchForm);
*/

class SearchForm extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector('input[type="search"]');

		if (this.input) {
			this.input.form.addEventListener('reset', this.onFormReset.bind(this));

			// Debounce input listener tetap aktif (kalau predictive search masih digunakan)
			this.input.addEventListener(
				'input',
				debounce((event) => {
					this.onChange(event);
				}, 300).bind(this)
			);

			// 🔹 Tangani submit pencarian
			this.input.form.addEventListener('submit', (e) => {
				const val = (this.input.value || '').toLowerCase().trim();

				// 🔸 Daftar kata → koleksi
				const collectionRedirects = {
					'3 3 field trip': '/id/collections/3-3-field-trip',
'aksesoris': '/id/collections/aksesoris',
'aland': '/id/collections/aland',
'ames': '/id/collections/ames',
'atelier de lumen': '/id/collections/atelier-de-lumen',
'lumen': '/id/collections/atelier-de-lumen',
'backpack': '/id/collections/backpack',
'baju': '/id/collections/baju',
'baju crop top': '/id/collections/baju-crop-top',
'baju rajut': '/id/collections/baju-rajut',
'baju rajut pria': '/id/collections/baju-rajut-pria',
'baju rajut wanita': '/id/collections/baju-rajut-wanita',
'baju wanita': '/id/collections/baju-wanita',
'brunch brother': '/id/collections/brunch-brother',
'cardigan': '/id/collections/cardigan',
'cardigan pria': '/id/collections/cardigan-pria',
'cardigan rajut': '/id/collections/cardigan-rajut',
'cardigan rajut wanita': '/id/collections/cardigan-rajut-wanita',
'cardigan wanita': '/id/collections/cardigan-wanita',
'cavish': '/id/collections/cavish',
'celana': '/id/collections/celana',
'celana cargo': '/id/collections/celana-cargo',
'celana cargo pria': '/id/collections/celana-cargo-pria',
'celana cargo wanita': '/id/collections/celana-cargo-wanita',
'celana denim': '/id/collections/celana-denim',
'celana hitam': '/id/collections/celana-hitam',
'celana jeans': '/id/collections/celana-jeans',
'celana jeans hitam': '/id/collections/celana-jeans-hitam',
'celana jeans pria': '/id/collections/celana-jeans-pria',
'celana jeans sobek': '/id/collections/celana-jeans-sobek',
'celana jeans sobek wanita': '/id/collections/celana-jeans-sobek-wanita',
'celana jeans wanita': '/id/collections/celana-jeans-wanita',
'celana jogger': '/id/collections/celana-jogger',
'celana jogger pria': '/id/collections/celana-jogger-pria',
'celana jogger wanita': '/id/collections/celana-jogger-wanita',
'celana panjang': '/id/collections/celana-panjang',
'celana panjang pria': '/id/collections/celana-panjang-pria',
'celana panjang wanita': '/id/collections/celana-panjang-wanita',
'celana pendek': '/id/collections/celana-pendek',
'celana pendek cargo wanita': '/id/collections/celana-pendek-cargo-wanita',
'celana pendek wanita': '/id/collections/celana-pendek-wanita',
'celana pria': '/id/collections/celana-pria',
'celana rok': '/id/collections/celana-rok',
'celana wanita': '/id/collections/celana-wanita',
'dress': '/id/collections/dress',
'drinkware': '/id/collections/drinkware',
'groundwork': '/id/collections/groundwork',
'hoodie': '/id/collections/hoodie',
'hoodie pria': '/id/collections/hoodie-pria',
'hoodie wanita': '/id/collections/hoodie-wanita',
'istkunst': '/id/collections/istkunst',
'jaket': '/id/collections/jaket',
'jaket hitam': '/id/collections/jaket-hitam',
'jaket hitam wanita': '/id/collections/jaket-hitam-wanita',
'jaket jeans': '/id/collections/jaket-jeans',
'jaket jeans pria': '/id/collections/jaket-jeans-pria',
'jaket kulit': '/id/collections/jaket-kulit',
'jaket kulit pria': '/id/collections/jaket-kulit-pria',
'jaket kulit wanita': '/id/collections/jaket-kulit-wanita',
'jaket oversize': '/id/collections/jaket-oversize',
'jaket oversize pria': '/id/collections/jaket-oversize-pria',
'jaket pria': '/id/collections/jaket-pria',
'jaket varsity': '/id/collections/jaket-varsity',
'jaket wanita': '/id/collections/jaket-wanita',
'kaos': '/id/collections/kaos',
'kaos crop': '/id/collections/kaos-crop',
'kaos hitam pria': '/id/collections/kaos-hitam-pria',
'kaos kaki': '/id/collections/kaos-kaki',
'kaos kerah': '/id/collections/kaos-kerah',
'kaos lengan panjang': '/id/collections/kaos-lengan-panjang',
'kaos lengan panjang pria': '/id/collections/kaos-lengan-panjang-pria',
'kaos lengan panjang wanita': '/id/collections/kaos-lengan-panjang-wanita',
'kaos lengan pendek': '/id/collections/kaos-lengan-pendek',
'baju lengan pendek': '/id/collections/kaos-lengan-pendek',
'kaos lengan pendek pria': '/id/collections/kaos-lengan-pendek-pria',
'kaos lengan pendek wanita': '/id/collections/kaos-lengan-pendek-wanita',
'kaos oversize': '/id/collections/kaos-oversize',
'kaos oversize pria': '/id/collections/kaos-oversize-pria',
'kaos oversize wanita': '/id/collections/kaos-oversize-wanita',
'kaos pria': '/id/collections/kaos-pria',
'kaos putih': '/id/collections/kaos-putih',
'kaos wanita': '/id/collections/kaos-wanita',
'kemeja': '/id/collections/kemeja',
'kemeja hitam': '/id/collections/kemeja-hitam',
'kemeja lengan panjang pria': '/id/collections/kemeja-lengan-panjang-pria',
'kemeja panjang wanita': '/id/collections/kemeja-panjang-wanita',
'kemeja pria': '/id/collections/kemeja-pria',
'kemeja wanita': '/id/collections/kemeja-wanita',
'keyring': '/id/collections/keyring',
'knitwear': '/id/collections/knitwear',
'land museum': '/id/collections/land-museum',
'mahagrid': '/id/collections/mahagrid',
'mmlg': '/id/collections/mmlg',
'mmw': '/id/collections/mmw',
'nasty fancy club': '/id/collections/nasty-fancy-club',
'nice ghost club': '/id/collections/nice-ghost-club',
'onepiece': '/id/collections/onepiece',
'others': '/id/collections/others',
'outer': '/id/collections/outer',
'pakaian': '/id/collections/pakaian',
'pouch': '/id/collections/pouch',
'rok': '/id/collections/rok',
'romantic crown': '/id/collections/romantic-crown',
'rompi': '/id/collections/rompi',
'slowacid': '/id/collections/slowacid',
'stationery': '/id/collections/stationery',
'sticker': '/id/collections/sticker',
'sweater': '/id/collections/sweater',
'sweater hitam wanita': '/id/collections/sweater-hitam-wanita',
'sweater oversize wanita': '/id/collections/sweater-oversize-wanita',
'sweater pria': '/id/collections/sweater-pria',
'sweater rajut': '/id/collections/sweater-rajut',
'sweater rajut pria': '/id/collections/sweater-rajut-pria',
'sweater rajut wanita': '/id/collections/sweater-rajut-wanita',
'sweater wanita': '/id/collections/sweater-wanita',
'tas': '/id/collections/tas',
'tas laptop': '/id/collections/tas-laptop',
'tas pria': '/id/collections/tas-pria',
'tas ransel': '/id/collections/tas-ransel',
'tas ransel pria': '/id/collections/tas-ransel-pria',
'tas ransel wanita': '/id/collections/tas-ransel-wanita',
'tas selempang': '/id/collections/tas-selempang',
'tas selempang pria': '/id/collections/tas-selempang-pria',
'tas selempang wanita': '/id/collections/tas-selempang-wanita',
'tas wanita': '/id/collections/tas-wanita',
'top': '/id/collections/top',
'topi': '/id/collections/topi',
'topi baseball': '/id/collections/topi-baseball',
'topi hitam': '/id/collections/topi-hitam',
'topi pria': '/id/collections/topi-pria',
'topi wanita': '/id/collections/topi-wanita',
'tote bag': '/id/collections/tote-bag',
'tote bag wanita': '/id/collections/tote-bag-wanita',
'unalloyed': '/id/collections/unalloyed',
'waikei': '/id/collections/waikei',
'wai kei': '/id/collections/waikei',
'youthbath': '/id/collections/youthbath',
'zero per zero': '/id/collections/zero-per-zero',
'kaos sablon': '/id/collections/kaos-sablon',
'baju kaos': '/id/collections/baju-kaos',
'rok jeans': '/id/collections/rok-jeans',
'celana cream': '/id/collections/celana-cream',
'kupluk': '/id/collections/kupluk',
'baju kaos pria': '/id/collections/baju-kaos-pria',
'tas perempuan': '/id/collections/tas-perempuan',
'topi bucket': '/id/collections/topi-bucket',
'tas kecil': '/id/collections/tas-kecil',
'baju lengan panjang': '/id/collections/baju-lengan-panjang',
'kaos hitam': '/id/collections/kaos-hitam',
'kaos jersey': '/id/collections/kaos-jersey',
'celana cargo pendek': '/id/collections/celana-cargo-pendek',
'baju kerah': '/id/collections/baju-kerah',
'jaket denim': '/id/collections/jaket-denim',
'baju pria': '/id/collections/baju-pria',
'baju casual pria': '/id/collections/baju-casual-pria',
'rok hitam': '/id/collections/rok-hitam',
'rok pendek': '/id/collections/rok-pendek',
'jaket casual pria': '/id/collections/jaket-casual-pria',
'celana hitam wanita': '/id/collections/celana-hitam-wanita',
'celana abu abu': '/id/collections/celana-abu-abu',
'jaket casual': '/id/collections/jaket-casual',
'celana cargo panjang': '/id/collections/celana-cargo-panjang',
'pakaian wanita': '/id/collections/pakaian-wanita'
				};

				// Jika cocok → redirect ke koleksi
				if (collectionRedirects[val]) {
					e.preventDefault();
					window.location.href = collectionRedirects[val];
					return;
				}

				// Jika tidak cocok → biarkan search normal
			});
		}
	}

	shouldResetForm() {
		return !document.querySelector('[aria-selected="true"] a');
	}

	onFormReset(event) {
		event.preventDefault();
		if (this.shouldResetForm()) {
			this.input.value = '';
			this.input.focus();
		}
	}
}

customElements.define('search-form', SearchForm);
